import { required } from 'vuelidate/lib/validators'

/**
 * Model "class" for Goal - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        goal: {
            label: 'LABEL_GOAL_DESCRIPTION',
            type: 'textarea',
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
        timeframe: {
            label: 'LABEL_GOAL_TIMEFRAME',
            type: 'select',
            options: {
                '1 week': 'FIELD_GOAL_TIMEFRAME_1_WEEK',
                '2 weeks': 'FIELD_GOAL_TIMEFRAME_2_WEEKS',
                '3 weeks': 'FIELD_GOAL_TIMEFRAME_3_WEEKS',
                '1 month': 'FIELD_GOAL_TIMEFRAME_1_MONTH',
                '2 months': 'FIELD_GOAL_TIMEFRAME_2_MONTHS',
                '3 months': 'FIELD_GOAL_TIMEFRAME_3_MONTHS',
                '6 months': 'FIELD_GOAL_TIMEFRAME_6_MONTHS',
                '9 months': 'FIELD_GOAL_TIMEFRAME_9_MONTHS',
                '12 months': 'FIELD_GOAL_TIMEFRAME_12_MONTHS',
            },
            nullOptionLabel: 'FIELD_GOAL_TIMEFRAME_PROMPT',
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
    }
}
